import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { Application } from 'src/app/services/application.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-application-details',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    TooltipModule,
    TranslateModule,
    ButtonModule
  ],
  templateUrl: './application-details.component.html',
  styleUrls: ['./application-details.component.scss']
})
export class ApplicationDetailsComponent implements OnInit, OnChanges {
  @Input() appData: Application | null = null;
  @Output() onCancel = new EventEmitter<void>();
  @Output() onUpdate = new EventEmitter<any>();
  appForm: FormGroup;

  submitted = false;
  isUpdating = false;
  disallowEdit = false;
  showOnUpdate = true;
  currentSelectedApp: Application | null = null;
  buttonName = 'UPDATE';

  constructor(private fb: FormBuilder) {
    this.appForm = this.fb.group({
      sid: [''],
      name: ['', [Validators.required, Validators.pattern(/^[A-Za-z][A-Za-z0-9\s-]*$/), Validators.maxLength(64)]],
      shortName: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z-][A-Za-z0-9-]*(\.[A-Za-z-][A-Za-z0-9-]*)*$/),
          Validators.maxLength(64)
        ]
      ]
    });
  }

  ngOnInit(): void {
    if (this.appData) {
      this.currentSelectedApp = this.appData;
      this.patchForm();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appData'] && this.appData) {
      this.currentSelectedApp = this.appData;
      this.patchForm();
      this.isUpdating = false;
      this.appForm.enable();
    }
  }

  patchForm() {
    if (this.appData) {
      this.appForm.patchValue({
        sid: this.appData.sid || this.appData.id,
        name: this.appData.name,
        shortName: this.appData.shortName
      });
    }
  }

  onApplicationUpdate() {
    this.submitted = true;
    if (this.appForm.invalid) {
      return;
    }

    const currentValues = this.appForm.getRawValue();
    const isChanged = currentValues.name !== this.appData?.name || currentValues.shortName !== this.appData?.shortName;

    if (!isChanged) {
      this.onCancel.emit();
      return;
    }

    this.isUpdating = true;
    this.appForm.disable();
    this.onUpdate.emit(currentValues);
  }
}
